import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["id", "name", "samplesOrder", "pipelines"];
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import { EXPERIMENT_SETTINGS_INFO_UPDATE } from 'redux/actionTypes/experimentSettings';
import fetchAPI from 'utils/http/fetchAPI';
var toApiV1 = function toApiV1(experimentV2) {
  var id = experimentV2.id,
    name = experimentV2.name,
    samplesOrder = experimentV2.samplesOrder,
    pipelines = experimentV2.pipelines,
    restOfExperiment = _objectWithoutProperties(experimentV2, _excluded);
  var pipelinesV1 = {
    gem2s: pipelines.gem2s,
    pipeline: pipelines.qc
  };
  var experimentV1 = _objectSpread(_objectSpread({}, restOfExperiment), {}, {
    experimentId: id,
    experimentName: name,
    projectId: id,
    sampleIds: samplesOrder,
    meta: pipelinesV1,
    // These are always created with the same value right now
    // when the UI is updated:
    //  - Organism is not going to be used anymore.
    //  - Type will be defined in the samples, not in the experiment.
    organism: null,
    type: '10x'
  });
  return experimentV1;
};
var reloadExperimentInfo = function reloadExperimentInfo() {
  var experimentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var id, experimentInfoV2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            id = experimentId !== null && experimentId !== void 0 ? experimentId : getState().experimentSettings.info.experimentId;
            _context.next = 3;
            return fetchAPI("/v2/experiments/".concat(id));
          case 3:
            experimentInfoV2 = _context.sent;
            dispatch({
              type: EXPERIMENT_SETTINGS_INFO_UPDATE,
              payload: toApiV1(experimentInfoV2)
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default reloadExperimentInfo;